module.exports = __webpack_public_path__ + "img/imgentrew2.cec3df3f.png";